import InterviewSectionPage from "../../modules/interviewSection/InterviewSectionPage";

export default InterviewSectionPage;
